module.exports = __webpack_public_path__ + "img/balibodySh4.c4fa4275.jpg";